import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const SECOND = 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
const WEEK = DAY * 7;
const MONTH = DAY * 30;
const YEAR = DAY * 365;

@Pipe({
    name: 'timeElapsed',
    standalone: false
})
export class TimeElapsedPipe implements PipeTransform {

  private readonly translateService = inject(TranslateService);

  public transform(value: string | Date | number): string {
    if (!value) {
      return '';
    }

    const date = new Date(value);
    const elapsedMs = Math.abs(Date.now() - date.getTime());

    if (elapsedMs < MINUTE) {
      const seconds = Math.max(1, Math.floor(elapsedMs / SECOND));
      return this.translateService.instant('COMMON.time_seconds_ago', { time: seconds });
    }

    if (elapsedMs < HOUR) {
      const minutes = Math.floor(elapsedMs / MINUTE);
      return this.translateService.instant('COMMON.time_minutes_ago', { time: minutes });
    }

    if (elapsedMs < DAY) {
      const hours = Math.floor(elapsedMs / HOUR);
      return this.translateService.instant('COMMON.time_hours_ago', { time: hours });
    }

    if (elapsedMs < WEEK) {
      const days = Math.floor(elapsedMs / DAY);
      return this.translateService.instant('COMMON.time_days_ago', { time: days });
    }

    if (elapsedMs < MONTH) {
      const weeks = Math.floor(elapsedMs / WEEK);
      return this.translateService.instant('COMMON.time_weeks_ago', { time: weeks });
    }

    if (elapsedMs < YEAR) {
      const months = Math.floor(elapsedMs / MONTH);
      return this.translateService.instant('COMMON.time_months_ago', { time: months });
    }

    const years = Math.floor(elapsedMs / YEAR);
    return this.translateService.instant('COMMON.time_years_ago', { time: years });
  }

}
